import React from 'react';
import NewLogin from '../../lis-login/components/lis-new-login-form';
import NewUserProfile from './lis-new-profile-component'

class Submenu extends React.Component {

    render() {
        const {
            isAuth
        } = this.props;

        if (!isAuth) {
            return (
                <ul className="nav-submenu" id="login">
                    <NewLogin
                        history={this.props.history}
                        isSubmenu={true}
                    />
                </ul>
            )
        }
        else {
            return (
                <ul className="nav-submenu" id="profile">
                    <NewUserProfile permissions={this.props.permissions} />
                </ul>
            )
        }
    }
}

export default Submenu;
